import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass';
import { FONT_SIZE, SPACE } from '@tcaster/tcaster-theme';

import { Text } from '../Base';

const WText = props => <Text.Subtitle color="white" {...props} />;

const Header = ({ title, left, right, children, cap, ...restProps }) => {
  const borderRadius = cap ? { style: { borderRadius: '4px 4px 0 0' } } : {};
  let titleComponent;
  if (React.isValidElement(children)) {
    titleComponent = children;
  } else if (left && right) {
    titleComponent = (
      <Flex justifyContent="space-between">
        <Box>
          <WText>{left}</WText>
        </Box>
        <Box>
          <WText>{right}</WText>
        </Box>
      </Flex>
    );
  } else if (React.isValidElement(title)) {
    titleComponent = title;
  } else {
    titleComponent = <WText>{children || title}</WText>;
  }
  return (
    <Box px={SPACE.medium} py={SPACE.small} bg="darkBlue" {...borderRadius} {...restProps}>
      {titleComponent}
    </Box>
  );
};

export { Header };
